import React, {useState, useEffect, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../../../constants/general-constants";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

export default function UtilisationChartBarProfile({}){
	
	const chartId = "utilisationchartbarprofile";
	
	const chartData = [
		{label:'07:00', utilisation:"5"},
		{label:'08:00', utilisation:"30"},
		{label:'09:00', utilisation:"60"},
		{label:'10:00', utilisation:"80"},
		{label:'12:00', utilisation:"80"},
		{label:'13:00', utilisation:"60"},
		{label:'14:00', utilisation:"90"},
		{label:'15:00', utilisation:"90"},
		{label:'16:00', utilisation:"70"},
		{label:'17:00', utilisation:"60"},
		{label:'18:00', utilisation:"30"},
		{label:'19:00', utilisation:"5"}
	];
	
	const graphs = [
		{title:"Occupied", keyColumn:"utilisation", color:"green"}
	];
	
	useEffect(() => {
		let categoryKey = "label";
		
		let x = am4core.create(chartId, am4charts.XYChart);
		x.fontSize = 10;
    x.fill='black';
    x.strokeAlpha=0;
		x.paddingTop = 0;
		x.paddingRight = 10;
		x.paddingLeft = 0;
		x.paddingBottom = 0;
		let categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
		categoryAxis.renderer.grid.template.strokeOpacity = 0;
		categoryAxis.renderer.labels.template.strokeOpacity=0;
		categoryAxis.renderer.labels.template.fillOpacity=1;
		categoryAxis.dataFields.category=categoryKey;	
		categoryAxis.renderer.labels.template.rotation=-90;
		categoryAxis.renderer.minGridDistance = 15;
		
		let valueAxis = x.yAxes.push(new am4charts.ValueAxis());
		valueAxis.renderer.grid.template.strokeOpacity = 0;
		valueAxis.renderer.labels.template.strokeOpacity=0;
		valueAxis.renderer.labels.template.fillOpacity=0;
		
		for(let i=0; i<graphs.length; i++){
	 		let series = x.series.push(new am4charts.ColumnSeries());
	 		series.name = graphs[i].title;
	    series.dataFields.categoryX = categoryKey;
	    series.dataFields.valueY = graphs[i].keyColumn;
	    series.fill = graphs[i].color;
	    series.stroke = graphs[i].color;
	    series.tooltipText = graphs[i].title + " ({categoryX}): {valueY}";
  		series.tooltip.label.wrap=true;
  		series.tooltip.label.width=300;
  		series.tooltip.label.fill='black';
  		series.stacked=true;
	  }
	   
	   x.cursor = new am4charts.XYCursor();
	   
			x.data = chartData;
			chart.current = x;
	}, [chartData, graphs]);
	
	const chart = useRef(null);
	
	
	
	const thisContainer = {
		display:'flex',
		width:"100%",
		height:"130px",
		fontWeight:"bold",
		flexDirection:"column",
		marginTop:"20px",
		alignItems:"center",
		justifyContent:"space-around"
	};
	
	const chartContainer ={ 
		display:"flex",
		width:"340px",
		height:"calc(100% - 0px)",
		marginTop:"0px",
		marginLeft:"-20px"
	};
	
	const buttonPanel = {
		display:"flex",
		alignSelf:"center",
		marginLeft:"15px"
	};
	
	const buttonPanelWeek = {
		display:"flex",
		alignItems:"center",
		height:"20px",
		justifyContent:"space-around",
		borderRadius:"6px",
		fontSize:"12px",
		color:'white',
		width:"120px",
		backgroundColor:"grey",
		fontWeight:"normal"
	};
	
	const buttonPanelDay = {
		display:"flex",
		alignItems:"center",
		height:"20px",
		justifyContent:"space-around",
		borderRadius:"6px",
		fontSize:"12px",
		color:'white',
		width:"120px",
		backgroundColor:"darkgreen",
		fontWeight:"normal",
		marginLeft:"-15px"
	};
	
	return (
		<div style={thisContainer}>
			<div style={chartContainer} id={chartId}>
			
			</div>
			<div style={buttonPanel}>
				<div style={buttonPanelWeek}>
					Weekly Profile
				</div>
				<div style={buttonPanelDay}>
					Daily Profile
				</div>
			</div>
		</div>
	);
}